// Angular
import { Component, Input, ViewChild, OnInit } from "@angular/core";
import { FormGroup, FormArray } from "@angular/forms";

// Afididum
import { Yii } from "libraries/interfaces/Yii";
import { AfidiumServiceFieldComponent } from "app_sasha/shared/components/afidium-service-field/afidium-service-field.component";
import { IFieldSpecs } from "libraries/module/formbuilder/fields/interfaces/field-specs";
import { AfidiumServiceFieldsetService } from "../../afidium-service-field/afidium-service-fieldset.service";
import { TEMPLATE_LABELS } from "app_sasha/shared/config/booking-wording";
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { faPlus } from "@fortawesome/free-solid-svg-icons/faPlus";


interface IFieldConfig {
    [name: string]: IFieldSpecs;
}

@Component({
    selector: 'afidium-service-fieldset',
    template: `
        <div class="sep-top">
            <collapsible [title]="afidiumServiceSearchTitle" [open]="open">
                <div class="col-to-row-s-tb" *ngFor="let form of form.controls.afidiumServices['controls']; let i = index">
                    <afidium-service-field
                            #dateAfidiumServiceField
                            [form]="form"
                            [index]="i"
                            (onFormArrayRemoved)="removeField($event)">
                    </afidium-service-field>
                </div>
                <btnForm styleType="actionHeaderLink"
                         (click)="addField()">
                    <fa-icon [icon]="iconPlus"></fa-icon>
                    {{afidiumServiceAddCriteria}}
                </btnForm>
            </collapsible>
        </div>
    `
})
export class AfidiumServiceFieldsetComponent implements OnInit {
    @Input()
    public form: FormGroup;

    @Input()
    public open: boolean = true;

    @ViewChild('dateBookingFieldSet')
    public dateAfidiumServiceField: AfidiumServiceFieldComponent;

    public readonly afidiumServiceSearchTitle: string = Yii.t('wui-sasha-js', 'Services Afidium - Eligibilité des dossiers');
    public readonly afidiumServiceAddCriteria: string = TEMPLATE_LABELS.afidiumServiceField;
    public iconPlus: IconDefinition = faPlus;

    public formFields: IFieldConfig;

    constructor(
        private afidiumServiceFieldSetService: AfidiumServiceFieldsetService,
    ) { }

    public ngOnInit(): void {
        const formArray: FormArray = this.form.controls.afidiumServices as FormArray;
        if(formArray.length === 0) {
            this.afidiumServiceFieldSetService.addService(this.form);
        }
    }

    public addField():void {
        this.afidiumServiceFieldSetService.addService(this.form);
    }


    public removeField(index:number):void {
      const oldField: FormArray = this.form.controls.afidiumServices as FormArray;
      oldField.removeAt(index);
    }
}
